module.exports = __webpack_public_path__ + "img/C2QB_green_btn_tall_hover_2x.9e1cee51.png";